import { GetAdditionalProgressionFlowsAvailableForJobRequest } from '@taxfyle/api-internal/internal/job_progression_pb'
import { collection } from 'infra/collection'
import { Id } from 'types/definitions'
import { AvailableJobProgressionFlowsDto } from '../dtos'
import { AvailableJobProgressionFlows } from './AvailableJobProgressionFlows'
import { JobProgressionAPI } from '../API'

export default class AvailableJobProgressionFlowsStore {
  constructor(private api: JobProgressionAPI) {}

  availableJobProgressionFlows = collection<
    AvailableJobProgressionFlowsDto,
    AvailableJobProgressionFlows
  >({
    create: () => new AvailableJobProgressionFlows(),
    getModelId: (p) => p.jobId,
    getDataId: (p) => p.jobId,
  })

  availableProgressionFlowsForJob = (jobId?: string) =>
    this.availableJobProgressionFlows.find((p) => p.jobId === jobId)

  /**
   * Fetch all available progression flows for a job.
   * @param jobId
   * @returns
   */
  async fetchAvailableJobProgressionFlows(jobId: Id) {
    const request = new GetAdditionalProgressionFlowsAvailableForJobRequest()
    request.setJobId(Id.assert(jobId))

    const response =
      await this.api.getAdditionalProgressionFlowsAvailableForJob(request)
    const obj = response.toObject()

    this.availableJobProgressionFlows.set({
      jobId,
      availableInventoryItemTaxExtensionFlows:
        obj?.inventoryItem?.taxExtension ?? null,
    })
  }
}
